export type SidebarNavMatchOptions = {
  to: string
  /** Quando true, só ativa na rota exata de `to`. */
  exact?: boolean
  /** Prefixo de seção; padrão é `to`. Usado quando o link aponta para uma subrota (ex.: /clientes/lista). */
  sectionPrefix?: string
}

/**
 * Indica se o item do menu lateral deve ficar ativo para o pathname atual.
 * Mantém o destaque em qualquer aba ou subrota da mesma seção.
 */
export function isSidebarNavActive(
  pathname: string,
  { to, exact, sectionPrefix }: SidebarNavMatchOptions
): boolean {
  if (exact) {
    return pathname === to
  }

  const prefix = sectionPrefix ?? to
  return pathname === prefix || pathname.startsWith(`${prefix}/`)
}
